import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "bin_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const choose = (choice) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ choice, ts: new Date().toISOString() }));
    } catch { /* storage unavailable */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[60] mb-14 border-t border-slate-200 bg-white/95 shadow-2xl backdrop-blur-md md:mb-0"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-4 sm:px-6 md:flex-row md:items-center lg:px-8">
        <div className="flex items-start gap-3 md:flex-1">
          <Cookie size={22} className="mt-0.5 shrink-0 text-amber-600" />
          <p className="text-xs leading-relaxed text-slate-600 sm:text-sm">
            We use cookies for <strong>Google AdSense advertising</strong>, <strong>analytics</strong>, and{" "}
            <strong>affiliate tracking</strong> — they help us keep the site free, measure performance, and credit
            our partners when you shop. Choose "Accept All" for personalized ads, or "Essential Only" to limit
            cookies to what the site needs to function. Read our{" "}
            <Link to="/legal/privacy-policy" className="font-semibold text-gold-600 underline">Privacy Policy</Link>{" "}
            and{" "}
            <Link to="/legal/cookie-policy" className="font-semibold text-gold-600 underline">Cookie Policy</Link>.
          </p>
        </div>
        <div className="flex shrink-0 flex-wrap gap-2">
          <button
            data-testid="cookie-accept-button"
            onClick={() => choose("accept_all")}
            className="rounded-xl bg-gold-600 px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-gold-700"
          >
            Accept All
          </button>
          <button
            data-testid="cookie-essential-button"
            onClick={() => choose("essential_only")}
            className="rounded-xl border border-slate-300 bg-white px-5 py-2.5 text-sm font-bold text-slate-700 transition-colors hover:bg-slate-100"
          >
            Essential Only
          </button>
          <button
            data-testid="cookie-decline-button"
            onClick={() => choose("decline")}
            className="rounded-xl px-5 py-2.5 text-sm font-semibold text-slate-500 transition-colors hover:bg-slate-100"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};
